import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';


const BranchCreate = (props) => {
    const history = useHistory();

    const [name, setName] = useState("");
    const [branchCode, setBranchCode] = useState("");
    const [contactNumber1, setContactNumber1] = useState("");
    const [email, setEmail] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [cinNumber, setCINNumber] = useState("");
    const [addressLine, setAddressLine1] = useState("");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const { isAuthenticated, companyId, userId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, userId, token, logout]);

    const clearForm = () => {
        setName("");
        setBranchCode("");
        setContactNumber1("");
        setEmail("");
        setGstNumber("");
        setCINNumber("");
        setAddressLine1("");
    };

    const submitData = async (e) => {
        e.preventDefault();
        if (!name || !contactNumber1 || !branchCode) {
            setErrorMessage("All fields are required!");
            return;
        }

        const CompanyCreateData = {
            Name: name,
            BranchCode: branchCode,
            ContactNumber1: contactNumber1,
            Email: email,
            GSTNumber: gstNumber,
            CINNumber: cinNumber,
            Addressline: addressLine,
            CompanyId: companyId,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('BranchApi', CompanyCreateData, token)
            .then((response) => {
                console.log('Branch Created success:', response);
                setSuccessMessage("Branch Created successful!");
                setErrorMessage("");
                clearForm();
                history.push('/branchIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Branch Create error:', error);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    /* End API */

    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex'>
                        <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Branch Create</h5>
                        <Button

                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                            onClick={submitData}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />  <b>SAVE</b>

                        </Button>

                        <Button
                           
                            component={Link}
                            to="/branchIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' ,color:'brown',fontWeight: 'bolder'}}
                        >
                           <ReplyAllIcon  style={{ marginLeft: '8px' ,color:'brown', fontWeight: 'bolder'}}/> BACK TO LIST
                        </Button>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Branch Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Branch name"
                                required
                                maxLength={50}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="companyCode">
                                Branch Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={branchCode}
                                onChange={(e) => setBranchCode(e.target.value)}
                                type="text"
                                placeholder="Enter Branch Code"
                            />
                        </div>
                    </div>


                    <div className="w-full mb-4 flex">

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber1">
                                Contact Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={contactNumber1} onChange={(e) => setContactNumber1(e.target.value)} type="text" placeholder="Enter Contact Number 1"
                                required
                                maxLength={15}
                                pattern={phoneNumberPattern.source}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={email} onChange={(e) => setEmail(e.target.value)} type="text" placeholder="Enter Email"
                                maxLength={40}
                                pattern={emailPattern.source}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="gstNumber">
                                GST Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} maxLength={15} type="text" placeholder="Enter GST Number" />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="gstNumber">
                                CIN Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={cinNumber} onChange={(e) => setCINNumber(e.target.value)} maxLength={30} type="text" placeholder="Enter CIN Number" />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-full mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                Address Line
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={addressLine} onChange={(e) => setAddressLine1(e.target.value)} type="text" placeholder="Enter Address Line "
                                maxLength={200}
                                required
                            />
                        </div>

                    </div>

                </form>
            </div>
        </Fragment>
    );
}


export default BranchCreate


